import {PresetGroupProps, PresetProps, PresetSubGroupProps} from "../../../types/PresetProps";
import useUserContext from "../../../hooks/useUserContext";
import {emojiByGroupId} from "./emojiByGroupId";
import React, {useEffect} from "react";
import {
    formatDate,
    formatDateNoTime, formatDateWithAMPM,
    millisecondsToHuman
} from "../../../utils/friendlyDate";
import {numberToPosition} from "../../../utils/numberToPosition";
import {Button} from "antd";
import WhatsappBackground from "../../../assets/images/whatsapp-default-wallpaper.png";
import Sunglasses from "../../../assets/images/sunglasses.png";
import {useSteps} from "../../../hooks/useSteps";

interface PreviewPresetsProps {
    presets: PresetProps[];
    selectedGroup?: PresetGroupProps;
    selectedSubGroup?: PresetSubGroupProps | null;
    onBackClick: () => void;
    onTemplatePlanApproved: () => void;
    isLoading: boolean;
}

const PreviewPresets = ({ presets, selectedGroup, selectedSubGroup, onBackClick, onTemplatePlanApproved, isLoading }: PreviewPresetsProps) => {
    const selectedPresets = presets?.filter(preset => preset.presetGroupId === selectedGroup?.id && preset.presetSubGroupId === selectedSubGroup?.id);
    const { user, selectedDomain } = useUserContext();
    const { goNext, goBack } = useSteps();
    const abandonedTime = 10;

    const onBack = () => {
        goBack();
        onBackClick();
    }

    const onApprove = () => {
        goNext();
        onTemplatePlanApproved();
    }

    const messageTime = (abandonedTime: number, triggerDelay: number) => {
        const time = new Date();
        time.setHours(10);
        time.setMinutes(0);
        const initialTime = time.getTime();
        const triggerTime = new Date(initialTime + triggerDelay*60*1000);
        return formatDateWithAMPM(triggerTime);

    }

    const getPreviewContent = (content: string) => {
        return content
            .replace(/\{\{name}}/g, (user?.name.split(' ')[0] || 'John'))
            .replace(/\{\{cart}}/g, ('1 T-Shirt and 2 Socks'))
            .replace(/\{\{coupon code}}/g, ('WB5D3S'))
            .replace(/\{\{shop}}/g, (selectedDomain || ''))
            .replace(/\{\{price}}/g, '$9.99');
    }

    return <div className="preview-presets">
        {/*<div className="title-container">*/}
        {/*    <Button type="text" size="large" onClick={onBack}>Back</Button>*/}
        {/*    <div className="emoji-title">*/}
        {/*        <div className="emoji">*/}
        {/*            <div className="emoji-inner">*/}
        {/*                {selectedGroup?.id && emojiByGroupId(selectedGroup.id)}*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*        <div className="label">{selectedGroup?.title} ({selectedSubGroup?.totalMessages} Messages)</div>*/}
        {/*    </div>*/}
        {/*    <div style={{ width: "70px" }} />*/}
        {/*</div>*/}
        {/*<div className="bottom-border" />*/}
        <div className="sub-title">
            Excellent selection! <br />Please review the messages we’ve prepared for you<br /><br />
        </div>
        <div className="preview-form">
            <div className="preview-list">
                <div className="checkout-dot">
                    <div className="description">Example checkout was created and abandoned. Recovery process starts</div>
                </div>
                <div className="timeline" />
                <div className="whatsapp-background" style={{background: `url(${WhatsappBackground})` }} />
                {selectedPresets?.map((preset, index) =>
                    <div key={`preview-preset-${preset.id}`} className='preview-preset right'>
                        <div className="message-image"><img src={Sunglasses} /></div>
                        <div className="message-content">{preset.content}</div>
                        <div className="message-button">Complete Your Purchase</div>
                        <div className="message-button">Opt-out from this order</div>
                        <div className="message-time">{messageTime(abandonedTime, preset.triggerDelay)}</div>
                        <div className="timeline-dot">
                            <div className="description">
                                <div>The {numberToPosition(index + 1)}{index + 1 === selectedPresets.length ? ' and last' : ''}  attempt to recover the cart is sent <span>{millisecondsToHuman(preset.triggerDelay * 60 * 1000)}</span> after the checkout is created, unless the order is completed beforehand.</div>
                                <div className="note">* Once this message preset plan is approved, you will have the option to edit the message content and adjust the sending times.</div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
        <div className="action-bar">
            <Button type="default" disabled={isLoading} size="large" onClick={onBackClick}>Select Other Presets</Button>
            <Button type="primary" loading={isLoading} size="large" onClick={onApprove}>Approve & Create Templates</Button>
        </div>
    </div>
}

export default PreviewPresets;